/**
 * @generated SignedSource<<203009627dd45a36b8aae18c3a29b6ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TrainingSourceKind = "knowledge_base" | "web_crawl" | "%future added value";
export type DeleteTrainingSourceButtonMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
  kinds?: ReadonlyArray<TrainingSourceKind> | null;
};
export type DeleteTrainingSourceButtonMutation$data = {
  readonly response: {
    readonly deletedSourceId: string | null;
    readonly organization: {
      readonly trainingDataCount: number;
      readonly trainingSources: {
        readonly totalCount: number;
      };
    };
  };
};
export type DeleteTrainingSourceButtonMutation = {
  response: DeleteTrainingSourceButtonMutation$data;
  variables: DeleteTrainingSourceButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "kinds"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedSourceId",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "kinds",
    "variableName": "kinds"
  }
],
v6 = {
  "alias": null,
  "args": (v5/*: any*/),
  "kind": "ScalarField",
  "name": "trainingDataCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": (v5/*: any*/),
  "concreteType": "TrainingSourceNodeConnection",
  "kind": "LinkedField",
  "name": "trainingSources",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteTrainingSourceButtonMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v3/*: any*/),
        "concreteType": "DeleteTrainingSourceResponse",
        "kind": "LinkedField",
        "name": "deleteTrainingSource",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DeleteTrainingSourceButtonMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v3/*: any*/),
        "concreteType": "DeleteTrainingSourceResponse",
        "kind": "LinkedField",
        "name": "deleteTrainingSource",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedSourceId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "178e52062a806c11daba7597fb97d0a5",
    "id": null,
    "metadata": {},
    "name": "DeleteTrainingSourceButtonMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteTrainingSourceButtonMutation(\n  $id: ID!\n  $kinds: [TrainingSourceKind!]\n) {\n  response: deleteTrainingSource(id: $id) {\n    deletedSourceId\n    organization {\n      trainingDataCount(kinds: $kinds)\n      trainingSources(kinds: $kinds) {\n        totalCount\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cf73269a616c4c859177016d7b4914bf";

export default node;
